import { isUndefined, noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import { AssignmentPreviewWarningBanner } from 'domains/assignments/Components/AssignmentPreviewBanner';
import { useNavigation } from 'utils/hooks/useNavigation';
import CustomStructuredActivity from 'domains/customStructuredActivities/Page';

export const PreviewCustomStructuredActivity = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { params } = useNavigation();

  const { customStructuredActivityId } = params;
  if (isUndefined(customStructuredActivityId)) {
    throw new Error(t('notFound.pageTitle'));
  }

  return (
    <>
      <AssignmentPreviewWarningBanner />
      <div className="mb-128">
        <CustomStructuredActivity structuredActivityId={customStructuredActivityId} onSubmit={noop} previewMode />
      </div>
    </>
  );
};
